// @generated by protoc-gen-connect-query v1.4.1 with parameter "target=ts"
// @generated from file no/jotta/openapi/wopi.proto (package no.jotta.openapi, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { MethodKind } from "@bufbuild/protobuf";
import { GetLinksRequest, GetLinksResponse, UpdateWopiConsentRequest, UpdateWopiConsentResponse } from "./wopi_pb.js";
/**
 * GetLinks can be used to open a frame to Office Online using a hostpage (web page) as described here:
 * See: https://wopi.readthedocs.io/en/latest/hostpage.html#host-page
 *
 * @generated from rpc no.jotta.openapi.WopiService.GetLinks
 */
export const getLinks = {
    localName: "getLinks",
    name: "GetLinks",
    kind: MethodKind.Unary,
    I: GetLinksRequest,
    O: GetLinksResponse,
    service: {
        typeName: "no.jotta.openapi.WopiService"
    }
};
/**
 * Updates the Office Online privacy policy consent.
 *
 * @generated from rpc no.jotta.openapi.WopiService.UpdateWopiConsent
 */
export const updateWopiConsent = {
    localName: "updateWopiConsent",
    name: "UpdateWopiConsent",
    kind: MethodKind.Unary,
    I: UpdateWopiConsentRequest,
    O: UpdateWopiConsentResponse,
    service: {
        typeName: "no.jotta.openapi.WopiService"
    }
};
